import React, {useState, useEffect} from 'react';
import { List,  Tag, Space, Badge, Button } from 'antd';
import { RightOutlined } from '@ant-design/icons';

import './adpackagecard.css';



const AdOrderTable = (props) => {
  const {  data, selectedItem, onSelect } = props;
  const [select, setSelect] = useState(selectedItem || "");

  const onSelectChange = (e) => {
    if(onSelect){
        onSelect(e);
      }
      setSelect(e._id);
  }

  useEffect(() => {
     setSelect(selectedItem);
   }, [select,selectedItem]);

  return (
    <List
      className="ordertable"
      itemLayout="horizontal"
      dataSource={data}
      renderItem={(item) => (
          <List.Item
            actions={[<Button type="link" icon={<RightOutlined />} onClick={onSelectChange.bind(this,item)} />]}
          >
            <List.Item.Meta
              title={item.title}
              description={
                <div>
                  <div>{item.assetId}</div>
                  <Space size={[0, 8]} wrap style={{marginTop: '5px'}}>
                    <Tag color="magenta">{item.format}</Tag>
                    {
                      item.free &&
                      <Tag color="orange">{`default`}</Tag>
                    }
                    {
                      item.tag && item.tag.map((tag,k) => <Tag key={k} color="green">{tag}</Tag>)
                    }
                  </Space>
                </div>

              }
            />
            {item.asset && item.format === 'image' && <img style={{maxHeight:'100px', maxWidth:'300px', marginRight: "20px"}} src={item.asset || ''} alt={item.assetId || ''} />}
            <Badge status={item.status.type} text={item.status.text} />
          </List.Item>
      )}
    />
  );
};

export default AdOrderTable;